module.exports = __webpack_public_path__ + "9b660924bc3cef105e8a2a3a8f266a7d.png";